import styled from 'styled-components';
import { textblocks } from 'seal-ui-components';
import { getBaseTheme } from '@Themes';

const { texts, spaces } = getBaseTheme();

export const Container = styled.div({
    height: 54,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: `${spaces.default.xs} ${spaces.default.s} ${spaces.default.xs} 13%`,
    backgroundColor: 'white'
});

export const CheckTitleWrapper = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: ${spaces.default.xs};
    line-height: ${texts.sizes.default.lineHeight};
`;

export const Title = styled(textblocks.Text)`
    font-size: ${texts.sizes.s.fontSize};
`;
